import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";


export class PlanningLeftoverTimelineItemsCtrl implements IController {
  leftovers: any;
  stopsWarning: any;
  selectedJobIds: any;
  onSelect: Function;

  public limit: any;
  public offSet: any;
  public displayedLeftOvers: any;


  /* @ngInject */
  constructor(private $mdDialog) {
  }

  $onInit() {
    this.limit = 6;
    this.offSet = 0;

    this.displayedLeftOvers = _.take(this.leftovers, this.limit);
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    this.$onInit();
  }


  isLeftOverSelected(job) {
    return _.includes(this.selectedJobIds, job.id);
  }

  onNext() {
    this.offSet = this.offSet + this.limit;
    this.displayedLeftOvers = _.slice(this.leftovers, this.offSet, (this.offSet + this.limit));
  }

  onPrev() {
    this.offSet = this.offSet - this.limit;
    this.displayedLeftOvers = _.slice(this.leftovers, this.offSet, (this.offSet + this.limit));
  }

  getAllDraggedLeftOverJobs(draggedJob) {
    const isDraggedSelected: boolean = this.isLeftOverSelected(draggedJob);
    return isDraggedSelected ?
      _.filter(this.leftovers, (job) => {
        return _.includes(this.selectedJobIds, job.id);
      }) : [draggedJob]
  }

  onLeftoverDragStart(event, draggedLeftOver) {
    const draggedItems = this.getAllDraggedLeftOverJobs(draggedLeftOver);
    const leftOversTimelineItems = _.map(draggedItems, (job) => {

      return {
        content: 'LeftOver',
        stopIds: _.map(job.stops, 'id'),
        jobIds: [job.id],
        jobType: job.jobType,
        skills: job.skills,
        // type: 'STOP'
      }
    });
    event.originalEvent.dataTransfer.setData('text', JSON.stringify({
      content: 'LeftOvers',
      items: leftOversTimelineItems
    }));
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningLeftoverTimelineItems', {
    bindings: {
      leftovers: '<',
      stopsWarning: '<',
      selectedJobIds: '<',
      onSelect: '&'
    },
    template: require('./planning-leftover-timeline-items.html').default,
    controller: PlanningLeftoverTimelineItemsCtrl
  });
